import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as LogoIcon } from '../../icons/LogoGroup.svg';
import { PanelToggleIcon } from './SidebarIcons';

interface SidebarHeaderProps {
  open: boolean;
  collapsible: boolean;
  sidebarToggle: () => void;
}

const SidebarHeader = ({ open, collapsible, sidebarToggle } : SidebarHeaderProps) => {
  const onClick = () => {
    if (collapsible) {
      sidebarToggle();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: open ? 'space-between' : 'center',
        gap: '9px',
        padding: '4px 16px',
        marginBottom: '16px',
      }}
    >
      {open && (
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <LogoIcon style={{ height: 26, display: 'block' }} />
        </Box>
      )}
      <IconButton
        onClick={onClick}
        aria-label="Toggle navigation"
        aria-expanded={open}
        sx={{
          width: 32,
          height: 32,
          borderRadius: '8px',
          color: '#5f5d75',
          flex: 'none',
          '&:hover': {
            backgroundColor: '#eef2f0',
            color: '#16141d',
          },
        }}
      >
        <PanelToggleIcon />
      </IconButton>
    </Box>
  );
};

export default SidebarHeader;
